import { Button, Group, Modal, Text } from "@mantine/core";

interface Props {
  opened: boolean;
  onReload: () => void;
}

export function ConflictReloadModal({ opened, onReload }: Props) {
  return (
    <Modal opened={opened} onClose={onReload} withCloseButton={false} title="Зөрчил илэрлээ" centered>
      <Text size="sm" mb="md">
        Энэ бичлэгийг өөр сесс хооронд өөрчилсөн байна. Үргэлжлүүлэхийн тулд дахин ачаална уу.
      </Text>
      <Group justify="flex-end">
        <Button onClick={onReload}>Дахин ачаалах</Button>
      </Group>
    </Modal>
  );
}
